import React from 'react';
import { Link } from 'react-router-dom';
import { resolvePartnerNavTo } from '../config/partnerPanel';
import { brandLogos } from '../config/brand';
import { siteFooter } from '../data/siteFooter';
import { PartnerPanelLink } from './PartnerPanelLink';

export const SiteFooter: React.FC = () => {
  const d = siteFooter;

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__top">
          <div className="site-footer__brand">
            <Link to="/" className="site-footer__brand-link" aria-label={`${d.brandName} home`}>
              <img
                src={brandLogos.markDark}
                alt={d.brandName}
                className="site-footer__logo"
                width={160}
                height={32}
              />
            </Link>
            <p className="site-footer__tagline">{d.tagline}</p>
          </div>

          <div className="site-footer__columns">
            {d.columns.map((col) => (
              <nav key={col.title} className="site-footer__col" aria-label={col.title}>
                <p className="site-footer__col-title">{col.title}</p>
                <ul className="site-footer__links">
                  {col.links.map((item) => (
                    <li key={`${col.title}-${item.label}`}>
                      <PartnerPanelLink to={resolvePartnerNavTo(item.to)} className="site-footer__link">
                        {item.label}
                      </PartnerPanelLink>
                    </li>
                  ))}
                </ul>
              </nav>
            ))}
          </div>
        </div>

        <div className="site-footer__rule" />

        <div className="site-footer__bottom">
          <div className="site-footer__legal-block">
            <div className="site-footer__legal-row">
              {d.legal.map((item, i) => (
                <React.Fragment key={item.label}>
                  {i > 0 ? <span className="site-footer__legal-sep" aria-hidden /> : null}
                  <PartnerPanelLink to={resolvePartnerNavTo(item.to)} className="site-footer__legal-link">
                    {item.label}
                  </PartnerPanelLink>
                </React.Fragment>
              ))}
            </div>
            <p className="site-footer__copyright">{d.brandName}. All Rights Reserved</p>
          </div>

          <div className="site-footer__contact">
            <p className="site-footer__contact-line">
              <span className="site-footer__contact-label">Contact: </span>
              <a href={`mailto:${d.contactEmail}`} className="site-footer__contact-value">
                {d.contactEmail}
              </a>
            </p>
            <p className="site-footer__contact-line">
              <a href={`tel:${d.contactPhone.replace(/\s/g, '')}`} className="site-footer__contact-value">
                {d.contactPhone}
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
